// eslint-disable-next-line no-unused-vars
import React, { useState, useContext, useEffect } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import {
  Button,
  FormGroup,
  FieldGroup,
  SelectField,
} from '@livechat/design-system'
import uuidv4 from 'uuid/v4'
import { AuthContext } from '../contexts/auth'
import SlackApiClient from '../api/slack'
import firebase from '../firebase'

const AddNotification = ({ notifications, groups, onChange }) => {
  const [isUpdating, setIsUpdating] = useState(false)
  const [isRefreshing, setIsRefreshing] = useState(false)
  const [groupId, setGroupId] = useState(null)
  const [channelId, setChannelId] = useState(null)
  const [localChannels, setLocalChannels] = useState([])
  const [localGroups, setLocalGroups] = useState([])
  const auth = useContext(AuthContext)
  const slackClient = new SlackApiClient()
  const existingGroups = notifications.map(notification => notification.groupId)

  const fetchChannels = async () => {
    try {
      const allChannels = await slackClient.getChannels(
        auth.slack.user_access_token
      )

      const selectChannels = allChannels
        // .filter(channel => !existingChannels.includes(channel.id))
        .map(channel => ({
          key: `${channel.id}`,
          props: {
            name: `#${channel.name}`,
            value: `${channel.id}`,
          },
        }))

      let generalChannelSelected = false
      selectChannels.some(channel => {
        if (channel.props.name === '#general') {
          setChannelId(channel.key)
          generalChannelSelected = true
          return true
        }

        return false
      })

      if (!generalChannelSelected) {
        setChannelId(null)
      }

      setLocalChannels(selectChannels)

      const selectGroups = groups
        .filter(group => !existingGroups.includes(`${group.id}`))
        .map(group => ({
          key: `${group.id}`,
          props: {
            name: group.name,
            value: `${group.id}`,
          },
        }))

      let generalGroupSelected = false
      selectGroups.some(group => {
        if (group.props.name === 'General') {
          setGroupId(group.key)
          generalGroupSelected = true
          return true
        }

        return false
      })

      if (!generalGroupSelected) {
        setGroupId(null)
      }
      setLocalGroups(selectGroups)
    } catch (error) {
      setLocalChannels([])
      setLocalGroups([])
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchChannels()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications])

  const handleChannelSelect = item => {
    setChannelId(item)
  }

  const handleGroupSelect = item => {
    setGroupId(item)
  }

  const getItemBody = props => {
    if (!props) {
      return null
    }
    return <div id={props.value}>{props.name}</div>
  }

  const getSelectedItemBody = props => {
    return <div id={props.value}>{props.name}</div>
  }

  const saveNotification = async () => {
    setIsUpdating(true)

    try {
      let firebaseApp

      switch (auth.appName) {
        case 'slack3':
          firebaseApp = firebase.slack3
          break

        case 'slack2':
          firebaseApp = firebase.slack2
          break

        default:
          firebaseApp = firebase.slack
      }

      const db = firebaseApp.firestore()
      const licensesRef = db
        .collection('licenses')
        .doc(`${auth.agentData.license}`)
      const doc = await licensesRef.get()
      const currentNotifications = doc.exists ? doc.data().notifications : []
      const newNotifications = [
        ...currentNotifications,
        {
          id: uuidv4(),
          channel_id: channelId,
          group_id: groupId,
          added: {
            by: auth.agentData.entity_id,
            on: new Date().toISOString(),
          },
        },
      ]

      await db
        .collection('licenses')
        .doc(`${auth.agentData.license}`)
        .update({
          notifications: newNotifications,
          updated_at: new Date().toISOString(),
        })
    } catch (err) {
      console.error(err)
    }

    setIsUpdating(false)

    onChange()
  }

  const refreshChannels = async () => {
    try {
      setIsRefreshing(true)

      await fetchChannels()
    } catch (err) {
      console.log('err', err)
    }

    setIsRefreshing(false)
  }

  return (
    <div
      css={css`
        .lc-field-label {
          font-weight: bold;
        }
      `}
    >
      <FormGroup>
        <FieldGroup
          inline
          stretch
          css={css`
            align-items: center;
          `}
        >
          <SelectField
            css={css`
              width: 100%;
            `}
            id="channel-id"
            items={localChannels}
            onItemSelect={handleChannelSelect}
            getItemBody={getItemBody}
            placeholder="Select public channel"
            getSelectedItemBody={getSelectedItemBody}
            selected={channelId}
            labelText="Slack Public Channel"
            search
            searchProperty="name"
            searchPlaceholder="Search..."
          />

          <SelectField
            css={css`
              width: 100%;
            `}
            id="group-id"
            items={localGroups}
            onItemSelect={handleGroupSelect}
            getItemBody={getItemBody}
            placeholder="Select group"
            getSelectedItemBody={getSelectedItemBody}
            selected={groupId}
            labelText="LiveChat Group"
            search
            searchProperty="name"
            searchPlaceholder="Search..."
          />

          <Button
            css={css`
              margin-right: 8px;
              margin-left: 8px;
              height: 42px;
              position: relative;
              top: 2px;
            `}
            primary
            onClick={saveNotification}
            disabled={!groupId || !channelId}
            loading={isUpdating}
          >
            Add new notification
          </Button>

          <Button
            css={css`
              margin-right: 8px;
              margin-left: 8px;
              height: 42px;
              position: relative;
              top: 2px;
              max-width: 70px;
            `}
            secondary
            onClick={refreshChannels}
            loading={isRefreshing}
          >
            Refresh
          </Button>
        </FieldGroup>
      </FormGroup>
    </div>
  )
}

export default AddNotification
